import { Component } from '@angular/core';
import { FileManagerContentComponent } from './file-manager-content.component';

@Component({
    standalone: false,
    selector: 'lib-global-file-manager-content',
  templateUrl: './file-manager-content.component.html',
  styleUrls: ['./file-manager-content.component.scss']
})
export class GlobalFileManagerContentComponent extends FileManagerContentComponent {
  constructor() {
    super('GlobalDirectoryEntry');
  }
}
